const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.app.visitedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userName: state => state.user.userName,
  loginId: state => state.user.loginId,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  userInfo: state => state.user.userInfo,

  expUser: state => state.user.expUser,
  initInfo:state => state.user.initInfo,

  systemParameter:state => state.user.systemParameter,
  unitDepartments:state => state.user.unitDepartments,

  curUnit:state => state.user.curUnit,
  curSelUnit:state => state.user.curSelUnit,
  curSelUnitId:state => state.user.curSelUnitId,

  curDept:state => state.user.curDept,
  curSelDept:state => state.user.curSelDept,
  curSelDeptId:state => state.user.curSelDeptId,
  sysConfig:state => state.user.sysConfig
}
export default getters



// WEBPACK FOOTER //
// ./src/common/vuex/modules/getters.js